// Client-side mirror of the server permission matrix (server/src/auth/can.ts)
// used ONLY to hide controls a role can't use — the server remains the
// enforcement layer on every route. Keep these role lists in sync with the
// matrix when it changes.

const has = (role: string | undefined, roles: string[]) =>
  !!role && (role === "super_admin" || roles.includes(role));

/** video.upload — Upload video / Add YouTube video buttons. */
export const canUploadVideo = (role?: string) =>
  has(role, ["campaign_owner", "content_producer"]);

/** issuance.send — Compose pack / New shared link buttons. */
export const canSendPacks = (role?: string) => has(role, ["ae", "people_ops"]);

/** playlist.create / update / delete — builder buttons. */
export const canManagePlaylists = (role?: string) =>
  has(role, ["ae", "campaign_owner"]);

/** campaign.create — New campaign button. */
export const canCreateCampaign = (role?: string) =>
  has(role, ["campaign_owner"]);

/** campaign.assignAssociate — Members button. */
export const canManageCampaignMembers = (role?: string) =>
  has(role, ["campaign_owner", "people_ops"]);

/** campaign.update — Edit campaign button (own-only enforced server-side). */
export const canEditCampaign = (role?: string) => has(role, ["campaign_owner"]);

/** campaign.delete / issuance.cancel any — super_admin only. */
export const isSuperAdmin = (role?: string) => role === "super_admin";
